"use client";

import { c as _c } from "react/compiler-runtime";
import { FiZap, FiUsers, FiFileText, FiPackage, FiUserCheck } from "react-icons/fi";
const FACTORS = [{
  id: "peer_data",
  label: "Peer data",
  description: "Real-world insights from other physicians",
  Icon: FiUsers
}, {
  id: "trial_results",
  label: "Trial results",
  description: "Phase 3 endpoints, NEJM/JAMA publications",
  Icon: FiFileText
}, {
  id: "samples",
  label: "Samples",
  description: "Hands-on starter pack to trial in clinic",
  Icon: FiPackage
}, {
  id: "rep_discussion",
  label: "Rep discussion",
  description: "Conversations with manufacturer reps",
  Icon: FiUserCheck
}];
const InfluencingFactor = t0 => {
  const $ = _c(23);
  const {
    influencingFactor,
    setInfluencingFactor,
    productName,
    onBack,
    onNext
  } = t0;
  const isFormValid = !!influencingFactor;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-2 sm:gap-3 mb-2"><div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-primary-primaryBlue/10 flex items-center justify-center flex-shrink-0"><FiZap className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-primary-primaryBlue" /></div><h2 className="text-base sm:text-xl font-bold text-gray-900 font-poppins">Influencing Factor</h2></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = productName || "this therapy";
  let t3;
  if ($[1] !== t2) {
    t3 = <p className="text-xs sm:text-sm text-gray-600 font-poppins mb-4 sm:mb-6">What would most influence your decision to adopt <span className="font-semibold">{t2}</span>?</p>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== influencingFactor || $[4] !== setInfluencingFactor) {
    t4 = FACTORS.map(t5 => {
      const {
        id,
        label,
        description,
        Icon
      } = t5;
      const selected = influencingFactor === id;
      return <button key={id} type="button" onClick={() => setInfluencingFactor(id)} aria-pressed={selected} className={`text-left flex items-start gap-3 p-3 sm:p-4 rounded-lg border-2 transition-all ${selected ? "border-primary-primaryBlue bg-primary-primaryBlue text-white shadow-sm" : "border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50"}`}><div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${selected ? "bg-white/20 text-white" : "bg-gray-100 text-gray-500"}`}><Icon className="w-4 h-4 sm:w-5 sm:h-5" /></div><div className="min-w-0 flex-1"><div className={`text-sm sm:text-base font-semibold font-poppins ${selected ? "text-white" : "text-gray-900"}`}>{label}</div><div className={`text-[11px] sm:text-xs font-poppins mt-0.5 ${selected ? "text-white/85" : "text-gray-600"}`}>{description}</div></div></button>;
    });
    $[3] = influencingFactor;
    $[4] = setInfluencingFactor;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className="flex-1 overflow-y-auto hide-scrollbar px-4 sm:px-6 py-3 sm:py-4"><div className="mb-4 sm:mb-6">{t1}{t3}{t5}</div></div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== onBack) {
    t7 = <button onClick={onBack} className="flex-1 border-2 border-gray-300 text-gray-700 text-sm sm:text-base font-semibold font-poppins rounded-lg py-2.5 sm:py-3 hover:bg-gray-50 transition-colors">Back</button>;
    $[11] = onBack;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = !isFormValid;
  const t9 = `flex-1 text-white rounded-lg text-sm sm:text-base font-semibold font-poppins py-2.5 sm:py-3 transition-all ${isFormValid ? "bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-md hover:shadow-lg transform hover:scale-[1.02]" : "bg-gray-300 cursor-not-allowed"}`;
  let t10;
  if ($[13] !== onNext || $[14] !== t8 || $[15] !== t9) {
    t10 = <button onClick={onNext} disabled={t8} className={t9}>Next</button>;
    $[13] = onNext;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7) {
    t11 = <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 bg-white flex gap-2 sm:gap-3 flex-shrink-0">{t7}{t10}</div>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t6) {
    t12 = <>{t6}{t11}</>;
    $[20] = t11;
    $[21] = t6;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};
export default InfluencingFactor;